import React from "react";
import { Grid, Row, Col } from "react-flexbox-grid";
import Dialog from "material-ui/Dialog";

import logo from "../../assets/logo.png";

import "./Payment.css";

const LANDING_URL = "https://www.pulser.co/";

const PERIODS = Object.freeze({
  ANNUAL: "annual",
  MONTH: "monthly"
});

const mock = [
  {
    links: {
      monthly:
        "https://checkout.bluesnap.com/buynow/checkout?sku3558984=1&storeid=576047",
      annual:
        "https://checkout.bluesnap.com/buynow/checkout?sku3559050=1&storeid=576047"
    },
    order: 4,
    id: 1,
    title: "Business",
    buyTitle: "BUY BUSINESS",
    amount: {
      monthly: 54,
      annual: 44
    },
    amountSymbol: "$",
    notes: "per user / month",
    notesDesc: {
      monthly: "billed monthly",
      annual: "billed annually"
    },
    description: "For teams looking to manage construction projects",
    isBest: false,
    descriptionList: [
      {
        have: true,
        count: "",
        text: (
          <span>
            <span className="list_item__count">Sync</span> office with field -{" "}
            <span className="list_item__count">manage</span> punch-list & tasks
            on mobile & desktop (
            <span className="list_item__count">unlimited</span>)
          </span>
        )
      },
      {
        have: true,
        count: "",
        text: (
          <span>
            <span className="list_item__count">Export</span> custom field
            reports (logo, signature, titles…) from mobile as PDFs (
            <span className="list_item__count">unlimited</span>)
          </span>
        )
      },
      {
        have: true,
        count: "",
        text: (
          <span>
            <span className="list_item__count">View</span> building plans (up to{" "}
            <span className="list_item__count">300</span> per project)
          </span>
        )
      },
      {
        have: true,
        count: "",
        text: (
          <span>
            <span className="list_item__count">Collaborate</span> with project
            members (up to <span className="list_item__count">8</span> members
            per project)
          </span>
        )
      },
      {
        have: true,
        count: "",
        text: (
          <span>
            <span className="list_item__count">Ensure</span> quality and prevent
            rework through <span className="list_item__count">Checklists</span>{" "}
            (up to <span className="list_item__count">15</span> per project)
          </span>
        )
      },
      {
        have: true,
        count: "",
        text: (
          <span>
            <span className="list_item__count">Master account</span> - auto
            collect employees and Subs work (photos & communication) to create a
            searchable company{" "}
            <span className="list_item__count">as built archive</span>
          </span>
        )
      }
    ]
  },
  {
    links: {
      monthly:
        "https://checkout.bluesnap.com/buynow/checkout?sku3558982=1&storeid=576047",
      annual:
        "https://checkout.bluesnap.com/buynow/checkout?sku3558988=1&storeid=576047"
    },
    order: 3,
    id: 2,
    title: "Premium",
    buyTitle: "BUY PREMIUM",
    amount: {
      monthly: 29,
      annual: 24
    },
    amountSymbol: "$",
    notes: "per user / month",
    notesDesc: {
      monthly: "billed monthly",
      annual: "billed annually"
    },
    description:
      "For more advanced Pros & teams looking to manage small construction projects​",
    isBest: true,
    descriptionList: [
      {
        have: true,
        count: "",
        text: (
          <span>
            <span className="list_item__count">Manage</span> punch-list & tasks
            on mobile & desktop (
            <span className="list_item__count">unlimited</span>)
          </span>
        )
      },
      {
        have: true,
        count: "",
        text: (
          <span>
            <span className="list_item__count">Export</span> custom field
            reports (logo, signature, titles…) from mobile as PDFs (
            <span className="list_item__count">unlimited</span>)
          </span>
        )
      },
      {
        have: true,
        count: "",
        text: (
          <span>
            <span className="list_item__count">View</span> building plans (up to{" "}
            <span className="list_item__count">20</span> per project)
          </span>
        )
      },
      {
        have: true,
        count: "",
        text: (
          <span>
            <span className="list_item__count">Collaborate</span> with project
            members (up to <span className="list_item__count">8</span> members
            per project)
          </span>
        )
      },
      {
        have: true,
        count: "",
        text: (
          <span>
            <span className="list_item__count">Ensure</span> quality and prevent
            rework through <span className="list_item__count">Checklists</span>{" "}
            (up to <span className="list_item__count">5</span> per project)
          </span>
        )
      },
      {
        have: false,
        count: "",
        text: ""
      }
    ]
  },
  {
    links: {
      monthly:
        "https://checkout.bluesnap.com/buynow/checkout?sku3558968=1&storeid=576047",
      annual:
        "https://checkout.bluesnap.com/buynow/checkout?sku3558986=1&storeid=576047"
    },
    order: 2,
    id: 3,
    title: "PRO",
    buyTitle: "BUY PRO",
    amount: {
      monthly: 24,
      annual: 19
    },
    amountSymbol: "$",
    notes: "per user / month",
    notesDesc: {
      monthly: "billed monthly",
      annual: "billed annually"
    },
    description:
      "For Pros looking to manage punch-list items & export field reports (as PDFs) from their mobile",
    isBest: false,
    descriptionList: [
      {
        have: true,
        count: "",
        text: (
          <span>
            <span className="list_item__count">Manage</span> punch-list & tasks
            on mobile (<span className="list_item__count">unlimited</span>)
          </span>
        )
      },
      {
        have: true,
        count: "",
        text: (
          <span>
            <span className="list_item__count">Export</span> field reports from
            mobile as PDFs (<span className="list_item__count">unlimited</span>)
          </span>
        )
      },
      {
        have: true,
        count: "",
        text: (
          <span>
            <span className="list_item__count">View</span> building plans (up to{" "}
            <span className="list_item__count">10</span> per project)
          </span>
        )
      },
      {
        have: true,
        count: "",
        text: (
          <span>
            <span className="list_item__count">Collaborate</span> with project
            members (up to <span className="list_item__count">5</span> members
            per project)
          </span>
        )
      },
      {
        have: false,
        count: "",
        text: ""
      },
      {
        have: false,
        count: "",
        text: ""
      }
    ]
  },
  {
    links: {
      monthly: false,
      annual: false
    },
    order: 1,
    id: 4,
    title: "Basic",
    buyTitle: "START FOR FREE",
    amount: {
      monthly: 0,
      annual: 0
    },
    isFree: true,
    amountSymbol: "$",
    notes: "per user / month",
    notesDesc: {
      monthly: "billed monthly",
      annual: "billed annually"
    },
    description: "FREE TRIAL",
    isBest: false,
    descriptionList: [
      {
        have: false,
        count: "",
        text: ""
      },
      {
        have: false,
        count: "",
        text: ""
      },
      {
        have: false,
        count: "",
        text: ""
      },
      {
        have: false,
        count: "",
        text: ""
      },
      {
        have: false,
        count: "",
        text: ""
      },
      {
        have: false,
        count: "",
        text: ""
      }
    ]
  }
];

const BtnPeriod = ({ period, isActive, click }) => (
  <div
    onClick={() => click(period)}
    className={`switcher-button ${isActive ? "active-switcher" : ""}`}
  >
    {period}
  </div>
);

const Card = ({
  title,
  amount,
  amountSymbol,
  notes,
  description,
  isBest,
  descriptionList,
  activePeriod,
  notesDesc,
  isHort,
  isOpen,
  onShowHide,
  buyTitle,
  isFree,
  onBuy,
  id,
  links
}) => (
  <div className="card-tariff">
    <div className="card-title">{title}</div>
    <div className="card-amount">
      <div className="card-amount_dollar">{amountSymbol}</div>
      <div className="card-amount_amount">{amount[activePeriod]}</div>
    </div>
    <div className="card-notes">
      <div className="notes_note">{notes}</div>
      <div className="notes_description">{notesDesc[activePeriod]}</div>
    </div>
    <div className="card-description">{description}</div>

    <div
      onClick={() => onBuy(id, links[activePeriod])}
      className={`buy-now ${isBest ? "buy-now_best" : ""} ${
        isFree ? "buy-now_free" : ""
      } `}
    >
      {buyTitle}
    </div>

    <div
      className={`card-description-list ${
        (isHort && isOpen) || !isHort
          ? "card-description_show"
          : "card-description_hide"
      }`}
    >
      {descriptionList.map(({ have, count, text }) => (
        <div className="card-description-list_item">
          <div
            className={`list_item__content ${have ? "" : "content-disabled"}`}
          >
            {count && <span className="list_item__count">{count}</span>}
            <span className="list_item__text">{text}</span>
          </div>
        </div>
      ))}
    </div>
    {isHort && (
      <div className="show-hide-futures" onClick={onShowHide}>
        {isHort && isOpen ? "Hide features" : "View features"}
      </div>
    )}
  </div>
);

class Payment extends React.Component {
  state = {
    activePeriod: PERIODS.ANNUAL,
    isMobile: true,
    openedCard: {},
    isOpenMenuMobile: false,
    showModalSuccess: false
  };

  onShowHide = title => {
    const { openedCard } = this.state;
    this.setState({
      openedCard: { ...openedCard, [title]: !openedCard[title] }
    });
  };

  onToggleMenu = () => {
    this.setState({ isOpenMenuMobile: !this.state.isOpenMenuMobile });
  };

  componentDidMount() {
    this._resizeHandler();
    window.addEventListener("resize", this._resizeHandler);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this._resizeHandler);
  }

  _resizeHandler = () =>
    window.innerWidth > 1024
      ? this.state.isMobile && this.setState({ isMobile: false })
      : !this.state.isMobile && this.setState({ isMobile: true });

  onChange = activePeriod => {
    this.setState({ activePeriod });
  };

  onBuy = (id, url) => {
     if(url) {
         const win = window.open(url, '_blank');
         win.focus();
     }

    if (id === 4) {
      this.setState({ showModalSuccess: true });
    }
  };

  render() {
    const {
      activePeriod,
      isMobile,
      openedCard,
      isOpenMenuMobile,
      showModalSuccess
    } = this.state;

    const sortMock = mock.sort((a, b) => (a.order > b.order ? 1 : -1));

    return (
      <div className="wrap-payments">
        <header className="nav-header">
          <div className="header-logo">
            <img src={logo} alt="logo" width="90" height="70" />
          </div>
          <div className={`topnav ${isOpenMenuMobile ? "responsive" : ""}`}>
            <a href={`${LANDING_URL}#home`} target="_blank">
              Home
            </a>
            <a href={`${LANDING_URL}#customers`} target="_blank">
              Customers
            </a>
            <a href={`${LANDING_URL}#product`} target="_blank">
              Product
            </a>
            <a href="#" className="active-header-link">
              Pricing
            </a>
            <a href={`${LANDING_URL}#contact`} target="_blank">
              Contact Us
            </a>
            <a href={`${LANDING_URL}member/?section=login`} target="_blank">
              Log In
            </a>
            <a href={`${LANDING_URL}member/`} target="_blank">
              Sign Up
            </a>
            <a className="icon" onClick={this.onToggleMenu}>
              <i className="fa fa-bars" />
            </a>
          </div>
        </header>

        <div className="header-image" />
        <div className="main-payment">
          <div className="wrap-switcher">
            <div className="switcher-period">
              {Object.values(PERIODS).map(val => (
                <BtnPeriod
                  click={this.onChange}
                  key={val}
                  period={val}
                  isActive={activePeriod === val}
                />
              ))}
            </div>
          </div>
          <div className="card-wrap">
            {sortMock.map(card => (
              <Card
                {...card}
                activePeriod={activePeriod}
                isHort={isMobile}
                onShowHide={() => this.onShowHide(card.title)}
                isOpen={openedCard[card.title]}
                onBuy={this.onBuy}
              />
            ))}
          </div>
        </div>

        <div className="payments_contacts-us">
          Unsure which plan is best for your team?{" "}
          <a href="mailto:info@pulser.co?subject=Pulser – Pricing Inquiry">
            Contact us
          </a>
           and we’ll help you get started.
        </div>

        <div className="faqs">
          <div className="faqs_title">Frequently asked questions</div>
          <div className="header-break" />
          <Grid fluid>
            <Row>
              <Col xs={12} sm={6} md={6} lg={6}>
                <div className="faqs_card__title">
                  Do you have project based pricing?
                </div>
                <div className="faqs_card__description">
                  Yes, if you are interested in a project based pricing, please
                  contact us at{" "}
                  <a href="mailto:info@pulser.co">info@pulser.co</a>. Once we
                  understand the specifics of your projects we can offer you a
                  project based pricing.
                </div>
              </Col>
              <Col xs={12} sm={6} md={6} lg={6}>
                <div className="faqs_card__title">
                  Do you provide discounts according to number of licenses?
                </div>
                <div className="faqs_card__description">
                  Yes, we offer discount packages for teams. If you need 5
                  licenses or more, please contact us at{" "}
                  <a href="mailto:info@pulser.co">info@pulser.co</a> so we can
                  better understand your needs and provide you a volume based
                  discount.
                </div>
              </Col>
            </Row>

            <Row>
              <Col xs={12} sm={6} md={6} lg={6}>
                <div className="faqs_card__title">
                  Does Pulser offer custom plans?
                </div>
                <div className="faqs_card__description">
                  Here at Pulser, we know that no two projects or companies are
                  the same. We offer custom pricing plans for unlimited users
                  across projects or companies, starting at 10 licenses. For
                  more information and to see if your project or company
                  qualify, please contact{" "}
                  <a href="mailto:info@pulser.co">info@pulser.co</a>.
                </div>
              </Col>
              <Col xs={12} sm={6} md={6} lg={6}>
                <div className="faqs_card__title">
                  How do I manage users and billing?
                </div>
                <div className="faqs_card__description">
                  Pro, Premium and Business customers are billed on a monthly or
                  annual basis, based on license count. Additional users will
                  result in additional charges, unless they already have their
                  own paying account. You can remove and manage your users at
                  anytime by asking us by email{" "}
                  <a href="mailto:info@pulser.co">info@pulser.co</a>.
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={6} md={6} lg={6}>
                <div className="faqs_card__title">
                  What if I&#39;m not satisfied with my plan?
                </div>
                <div className="faqs_card__description">
                  You can cancel your premium plans at anytime. If you are
                  considering canceling your premium account, please email us at{" "}
                  <a href="mailto:info@pulser.co">info@pulser.co</a>
                   and let us know your feedback or concerns. We’re constantly
                  improving Pulser based on suggestions from customers like you,
                  so we appreciate your feedback!
                </div>
              </Col>
              <Col xs={12} sm={6} md={6} lg={6}>
                <div className="faqs_card__title">
                  What training resources does Pulser offer?
                </div>
                <div className="faqs_card__description">
                  Pulser offers numerous free materials to help you get started,
                  including our webinars, tutorial videos, help resources, and
                  PDF guide. We also have a team of ex- construction
                  professionals that offer customized trainings and consulting
                  services on the best way to utilize Pulser for your company or
                  project team. Please contact{" "}
                  <a href="mailto:info@pulser.co">info@pulser.co</a>
                   to learn more.
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={6} md={6} lg={6}>
                <div className="faqs_card__title">
                  What does the free trial include?
                </div>
                <div className="faqs_card__description">
                  The free trial includes all core features with a limited
                  number of plans, reports and documents.
                  <a href="#">Contact us</a> to learn more about these features.
                </div>
              </Col>
              <Col xs={12} sm={6} md={6} lg={6}>
                <div className="faqs_card__title">
                  How do I train my team on Pulser?
                </div>
                <div className="faqs_card__description">
                  Training is an optional premium service if you purchase for
                  your team, project or company. There are options for virtual
                  consulting, which can be customized for companies or by the
                  roles of your users.
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={6} md={6} lg={6}>
                <div className="faqs_card__title">
                  What happens at the end of the free trial?
                </div>
                <div className="faqs_card__description">
                  At the end of 14 days, you’ll be prompted to upgrade to one of
                  our paid plans. There’s no action required if you wish to
                  cancel, and you can login at any time to upgrade and
                  reactivate your account. Project data you enter into Pulser
                  will not be deleted.
                </div>
              </Col>
              <Col xs={12} sm={6} md={6} lg={6}>
                <div className="faqs_card__title">
                  I have no credit card, how can I pay?
                </div>
                <div className="faqs_card__description">
                  If you don't have a credit card, you can pay us yearly (via
                  bank transfer). Simply contact David at{" "}
                  <a href="mailto:david@pulser.co">david@pulser.co</a>, mention
                  whichaccountyou prefer and we'll activate your account and
                  send you aninvoice
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={6} md={6} lg={6}>
                <div className="faqs_card__title">
                  Is my credit card data safe?
                </div>
                <div className="faqs_card__description">
                  It is. We don't store your data in our database, so there is
                  no risk losing your data. Your data is stored safely and PCI
                  compliant by{" "}
                  <a href="https://home.bluesnap.com/" target="_blank">
                    Bluesnap
                  </a>
                  , a very reliable and widely respected payment platform.
                </div>
              </Col>
              <Col xs={12} sm={6} md={6} lg={6}>
                <div className="faqs_card__title">
                  How do projects, plans and reports count?
                </div>
                <div className="faqs_card__description">
                  Plans refer to blueprints you load and share with other
                  project members on Pulser, not other types of documents. Every
                  team member that uses Pulser will need a subscription that
                  covers the Plans count across all projects in which they are a
                  team member. However, with Pulser, you can easily share your
                  work with team members that do not have Pulser – you can
                  export your work as PDF files that can be sent by different
                  ways such as whatsapp, emails or other sharing apps you use
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={6} md={6} lg={6}>
                <div className="faqs_card__title">
                  Do all project members need to have Pulser?
                </div>
                <div className="faqs_card__description">
                  No, you can add project members from your phone contacts. Then
                  you can assign issues to them and manage their work through
                  Pulser’s platform. However, as they do not have a Pulser
                  account they cannot resolve or close issues through Pulser –
                  you will need to export them their issues through PDF files
                  and manually close their issues in your Pulser account. In
                  addition, only Pulser members will not see the shared plans
                  that you upload and use in Pulser.
                </div>
              </Col>
              <Col xs={12} sm={6} md={6} lg={6}>
                <div className="faqs_card__title">
                  Do we need to use a Master Account and Pulser’s web app?
                </div>
                <div className="faqs_card__description">
                  Master account means that all of the work (projects, issues,
                  communication, plans and images) of your company employees who
                  use Pulser will automatically save in a common, searchable
                  repository. This is usually important in 2 cases:
                  <ol style={{ paddingLeft: "16px", margin: "0" }}>
                    <li>
                      When an employee leaves the company and you want your
                      organization to keep all of the information from the
                      projects he worked on, and
                    </li>
                    <li>
                      In future warranty claims when you need an easy way to
                      search in all of the images and issues of the company.
                    </li>
                  </ol>
                </div>
              </Col>
            </Row>

            <Row>
              <Col xs={12} sm={6} md={6} lg={6}>
                <div className="faqs_card__title">
                  Do you limit the number of projects a single user can open?
                </div>
                <div className="faqs_card__description">
                  Yes, in all of our programs a single user can open up to 5
                  real projects in a calendar year. A real project is a project
                  that is not used for training or testing and usually has more
                  than 15 issues or more than 10 building plans.
                </div>
              </Col>
              <Col xs={12} sm={6} md={6} lg={6}>
                <div className="faqs_card__title">
                  ​ Can I upgrade some of the fields of my plan?
                </div>
                <div className="faqs_card__description">
                  Yes, if, for example, you believe the PRO plan best meets your
                  needs but you require more than 5 project members then you can
                  contact us and we will be glad to increase the number of
                  project users within the PRO plan.
                </div>
              </Col>
            </Row>
          </Grid>
        </div>
        <div className="more-questions">
          Unsure which plan is best for your team? <a href="mailto:info@pulser.co">Contact us</a>
           and we’ll help you get started.
        </div>
        <Dialog
          bodyStyle={{ background: "#2ecc71", color: "#fff" }}
          autoDetectWindowHeight
          open={showModalSuccess}
          style={{ marginTop: "-70px" }}
          onRequestClose={() => {
            this.setState({ showModalSuccess: false });
          }}
        >
          <div className="payment-dialog-content">
            <h2>THANK YOU</h2>
            <h3>
              Please open the below link & register to Pulser on your mobile:
            </h3>
            <div>
              <a href="http://pulser.click/download">
                http://pulser.click/download
              </a>
            </div>
            <div style={{ paddingTop: "5px", paddingBottom: "20px" }}>
              <span>
                (or search for “pulser field construction” in your mobile app
                store)
              </span>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

export default Payment;
